import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list-sharp",
  "use": "icon-list-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-list-sharp\"><title>List</title><path fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"48\" d=\"M144 144h320M144 256h320M144 368h320\" /><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-linejoin=\"round\" stroke-width=\"32\" d=\"M64 128h32v32H64zM64 240h32v32H64zM64 352h32v32H64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol